// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c5964d19","703":"83f6793f"}[chunkId] + ".chunk.js";
};